import * as Sentry from '@sentry/react'

import { getDocumentDeliveryAttributes } from 'helpers/initialPageRenderMetrics'

type TSentryScope = {
  uuid: string
  cohort: string
  language: string
  country: string
}

type TInitialPageMetric = {
  name: string
  value: number | null
  uuid: string
  app: string
  screen: string
  cohort: string
  locale: string
  country: string
}

const INITIAL_PAGE_METRICS_SAMPLE_RATE = 0.1
const isInitialPageMetricsSampled =
  Math.random() < INITIAL_PAGE_METRICS_SAMPLE_RATE

export const setSentryScope = ({
  uuid,
  cohort,
  language,
  country,
}: TSentryScope): void => {
  if (!Sentry.isInitialized()) return

  try {
    Sentry.setUser(uuid ? { id: uuid } : null)

    Object.entries({ cohort, language, country }).forEach(([key, value]) => {
      Sentry.setTag(key, value || undefined)
    })
  } catch (error) {
    console.warn('setSentryScope failed', error)
  }
}

export const captureInitialPageMetric = ({
  name,
  value,
  uuid,
  app,
  screen,
  cohort,
  locale,
  country,
}: TInitialPageMetric): void => {
  if (
    value === null ||
    !isInitialPageMetricsSampled ||
    !Sentry.isInitialized() ||
    !uuid
  ) {
    return
  }

  try {
    Sentry.metrics.distribution(name, value, {
      unit: 'millisecond',
      attributes: {
        'user.id': uuid,
        app,
        screen,
        cohort,
        locale,
        country,
        ...getDocumentDeliveryAttributes(),
      },
    })
  } catch (error) {
    console.warn('captureInitialPageMetric failed', error)
  }
}
